module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_concept_02-12ea7c0d14d6f9f94abdd78936a519a9.jpg";